module.exports = __webpack_public_path__ + "static/media/natureswall2.88d7e940.jpg";